export const DEALER_SESSION_KEY = 'signalbridge.dealerAdmin';

export const DEALER_ID_HEADER = 'X-SignalBridge-Dealer-Id';
export const TENANT_ID_HEADER = 'X-SignalBridge-Tenant-Id';

export function readDealerAdminSession() {
  try {
    const raw = sessionStorage.getItem(DEALER_SESSION_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.dealerId || !parsed?.tenantId) return null;
    const tenantName = String(parsed.tenantName || '').trim();
    return {
      dealerId: String(parsed.dealerId),
      tenantId: String(parsed.tenantId),
      tenantName,
      algoDeviceSupport: parsed?.algoDeviceSupport === true,
    };
  } catch {
    return null;
  }
}

export function writeDealerAdminSession(dealerId, tenantId, extra = {}) {
  const nextDealerId = String(dealerId || '');
  const nextTenantId = String(tenantId || '');
  const providedName = String(extra?.tenantName || '').trim();
  const previous = readDealerAdminSession();
  const sameAssignment = previous?.dealerId === nextDealerId && previous?.tenantId === nextTenantId;
  const tenantName = providedName || (sameAssignment ? previous.tenantName : '');
  const algoDeviceSupport = extra?.algoDeviceSupport === true
    || (sameAssignment && extra?.algoDeviceSupport !== false && previous?.algoDeviceSupport === true);
  const payload = { dealerId: nextDealerId, tenantId: nextTenantId, algoDeviceSupport: algoDeviceSupport === true };
  if (tenantName) payload.tenantName = tenantName;
  sessionStorage.setItem(DEALER_SESSION_KEY, JSON.stringify(payload));
  import('../../services/homeLauncher/launcherIconCache')
    .then(mod => mod.clearLauncherIconCache())
    .catch(() => {});
}

export function clearDealerAdminSession() {
  sessionStorage.removeItem(DEALER_SESSION_KEY);
  import('../../services/homeLauncher/launcherIconCache')
    .then(mod => mod.clearLauncherIconCache())
    .catch(() => {});
}

export function dealerAdminHeaders() {
  const session = readDealerAdminSession();
  if (!session) return {};
  return {
    [DEALER_ID_HEADER]: session.dealerId,
    [TENANT_ID_HEADER]: session.tenantId,
  };
}

export function scopedTenantId(provided) {
  const session = readDealerAdminSession();
  if (session?.tenantId) return session.tenantId;
  const text = String(provided || '').trim();
  return text;
}

export function applyDealerTenantToUrl(url) {
  const session = readDealerAdminSession();
  if (!session?.tenantId || typeof url !== 'string' || !url.includes('?')) return url;
  const [path, query = ''] = url.split('?');
  const params = new URLSearchParams(query);
  let changed = false;
  if (params.has('tenantId')) {
    params.set('tenantId', session.tenantId);
    changed = true;
  }
  if (params.has('tenant_id')) {
    params.set('tenant_id', session.tenantId);
    changed = true;
  }
  return changed ? `${path}?${params.toString()}` : url;
}

export function applyDealerTenantToPayload(data) {
  const session = readDealerAdminSession();
  if (!session?.tenantId || !data || typeof data !== 'object' || Array.isArray(data)) return data;
  if (!('tenantId' in data) && !('tenant_id' in data)) return data;
  const next = { ...data };
  if ('tenantId' in next) next.tenantId = session.tenantId;
  if ('tenant_id' in next) next.tenant_id = session.tenantId;
  return next;
}
